<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.png" alt="" />
      <img
        class="avatar1"
        src="https://resource.3uplay.com/sys-feed/06404f71-6333-49c3-9fdb-809a54ea10352697235954475123493.webp"
        alt=""
      />
      <img
        class="avatar2"
        src="https://resource.3uplay.com/sys-feed/6783d3c5-9d5a-416c-8141-8aae94f23a606388657551175766430.webp"
        alt=""
      />
      <div class="dressup1">
        <span>繽紛聖誕！</span>
        <img
          src="https://resource.3uplay.com/sys-feed/5d29602d-4892-4a97-a548-0aeb60b1191b498511076890819749.webp"
          alt=""
        />
      </div>
      <div class="dressup2">
        <span>驚喜不斷~</span>
        <img
          src="https://resource.3uplay.com/sys-feed/5bb57799-7214-4193-a4d5-b3b8b617cc6b6025406573228810684.webp"
          alt=""
        />
      </div>
      <div class="score1">{{ score1 }} 個</div>
      <div class="score2">{{ score2 }} 個</div>
      <div class="all-score">{{ totalScore }} 個</div>
      <div class="top3-box">
        <div
          v-for="(item, index) of list.slice(0, 3)"
          :key="item.uuid"
          class="item"
          :class="`top${index + 1}`"
          @click="toPlayerDetail(item.uuid)"
        >
          <div class="left">
            <img :src="item.avatar_url" alt="排名頭像" class="" />
            <span class="user-name">{{ item.nickname }}</span>
          </div>
          <div class="right">
            <span class="scroe">{{ item.pingguo }}個</span>
          </div>
        </div>
      </div>
      <div class="score-board-box" @scroll.stop>
        <div
          class="item"
          v-for="(item, index) of list.slice(3)"
          :key="item.uuid"
          @click="toPlayerDetail(item.uuid)"
        >
          <div class="left">
            <span class="index">{{ index + 4 }}</span>
            <img :src="item.avatar_url" alt="排名頭像" class="" />
            <span class="user-name">{{ item.nickname }}</span>
          </div>
          <div class="right">
            <span class="scroe">{{ item.pingguo }}個</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ActivityBox',
  data() {
    return {
      list: [],
      totalScore: 0,
      score1: 0,
      score2: 0
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    }
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getMyscore(val);
        } else {
          this.myScore = 0;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getAllList() {
      try {
        const url = 'https://devops.nicee.app/api/christmas/rank';
        const { datas } = await this.$http.get(url);
        this.list = datas.map(item => {
          item.pingguo = Math.floor(item.pingguo);
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getMyscore(uuid) {
      try {
        const url = `https://devops.nicee.app/api/christmas/${uuid}`;
        const res = await this.$http.get(url);
        if (res) {
          this.score1 = res.nvsheng;
          this.score2 = res.juchang;
          this.totalScore = res.tangguo;
        }
      } catch (error) {
        console.log(error);
      }
    },
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    }
  },
  created() {
    this.getAllList();
  }
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #7c301e;
  overflow: auto;
  text-align: center;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .dressup1,
    .dressup2 {
      position: absolute;
      font-size: 0;
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 36px;
        color: white;
        z-index: 1;
      }
      img {
        width: 478px;
        height: auto;
      }
    }
    .dressup1 {
      top: 1803px;
      left: 394px;
    }
    .dressup2 {
      top: 2225px;
      left: 97px;
    }
    .avatar1,
    .avatar2 {
      position: absolute;
      width: 216px;
      height: 216px;
      object-fit: cover;
    }
    .avatar1 {
      position: absolute;
      top: 1804px;
      left: 138px;
    }
    .avatar2 {
      position: absolute;
      top: 2235px;
      left: 614px;
    }
    .score1,
    .score2 {
      position: absolute;
      color: #ffe28f;
      font-size: 30px;
      font-weight: 600;
      height: 52px;
      line-height: 52px;
      top: 5163px;
      left: 649px;
    }
    .score2 {
      top: 5216px;
    }
    .all-score {
      position: absolute;
      color: #ffe28f;
      font-size: 36px;
      font-weight: 600;
      left: 614px;
      top: 7403px;
    }
    .top3-box {
      position: absolute;
      top: 5597px;
      .item {
        height: 168px;
        padding-left: 219px;
        &.top1 {
          color: white;
        }
        &.top2 {
          color: #c14e33;
        }
        &.top3 {
          color: #7c301e;
        }
      }
    }
    .item {
      display: flex;
      align-items: center;
      // justify-content: space-between;
      width: 100%;
      height: 84px;
      font-size: 28px;
      margin-bottom: 27px;
      color: #7c301e;
      border-radius: 40px;
      padding: 0 20px 0 0;
      .left,
      .right {
        display: flex;
        align-items: center;
      }
      .right {
        margin-left: 30px;
      }
      .left {
        .index {
          margin-left: 30px;
          margin-right: 48px;
          width: 30px;
          text-align: right;
        }
        img {
          width: 78px;
          height: 78px;
          border-radius: 50%;
          margin-right: 66px;
          object-fit: cover;
          border: 2px solid black;
        }
        .user-name {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 306px;
        }
      }
      .right {
        img {
          width: 36px;
          margin: 0 0 0 14px;
        }
      }
    }

    .score-board-box {
      height: 930px;
      position: absolute;
      top: 6200px;
      left: 50%;
      transform: translateX(-50%);
      width: 740px;
      overflow: auto;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none;
      }
      .left {
        .index {
          margin-left: 0;
          margin-right: 78px;
        }
      }
    }
  }
}
</style>
